import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { F, Range, Kpis, QuoteTable, TrainingCard } from "@/components/sales/DashBits";

export default function SalesDashboard() {
  const { uid } = useParams();
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get(uid ? `/api/sales-dash/rep/${uid}` : "/api/sales-dash/me", { params: { days } }).then(r => setD(r.data)).catch(e => { toast.error(errMsg(e)); setD(false); }); }, [days, uid]);
  return (
    <div className="pt-24 pb-20 min-h-screen bg-[#f6f5f1]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }} data-testid="sales-dashboard">
      <div className="max-w-7xl mx-auto px-4 space-y-6">
        <div className="flex flex-wrap items-end gap-4"><div className="flex-1 min-w-[240px]"><p className="text-xs font-bold uppercase tracking-[0.25em] text-blue-600">{uid ? "Rep dashboard" : "My sales"}</p>
          <h1 className="text-4xl sm:text-5xl font-extrabold text-slate-900 tracking-tight" style={F} data-testid="sd-name">{d ? d.name : d === false ? "Sales dashboard" : "…"}</h1></div>
          <Range days={days} setDays={setDays} />{d?.manager && !uid && <Link to="/sales/manager" className="h-10 px-5 leading-10 rounded-full bg-amber-500 hover:bg-amber-400 text-slate-900 text-sm font-bold" data-testid="sd-manager-link">Team view</Link>}</div>
        {d === false ? <p className="text-slate-500">Not available.</p> : !d ? <p className="text-slate-400">Loading…</p> : <>
          <Kpis q={d.quotes} c={d.calls} t={d.training} />
          <div className="grid lg:grid-cols-[1fr_300px] gap-6 items-start">
            <QuoteTable rows={d.recent} />
            <div className="space-y-4"><TrainingCard t={d.training} />
              <section className="bg-white border border-slate-200 rounded-2xl p-5 text-sm space-y-1" data-testid="sd-pipeline"><p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 mb-1">Pipeline</p>
                <p>Assigned leads: <b>{d.leads}</b></p><p>Callbacks due: <b className={d.followups_due ? "text-red-600" : ""}>{d.followups_due}</b></p><p>Appointments booked: <b>{d.calls.appointments}</b></p></section>
              <p className="text-xs text-slate-500">Numbers come from quotes you sent, real payments received and your Call Desk calls. Commission estimates appear once a compensation plan is approved.</p></div>
          </div>
        </>}
      </div>
    </div>
  );
}
